<template>
    <Progressbar v-if="loading" />
    <NetworkError v-else-if="errors" @tryAgain="getData" />
    <div class="xl:w-6/12 2xl:w-4/12 h-full flex" v-else>
        <div class="card bg-white w-full my-auto">
            <div class="card-body flex flex-col justify-center items-center">
                <div class="flex items-center w-full">
                    <button :title="__('Back')" class="btn btn-sm btn-outline border-none hover:bg-gray-300 btn-circle"
                        v-if="returnStep == 'record'" @click="setReturnStep('add')">
                        <ArrowSmallRightIcon class="w-5 h-5 text-black" />
                    </button>
                    <p class="flex-1 text-center">
                        {{ returnStep == 'add' ? __('Select your product to return.') :
                            __('Items selected for return') }}</p>
                </div>
                <input type="text" :placeholder="__('Search for the desired product')" @keyup="searchProduct"
                    v-if="returnStep == 'add'"
                    class="input w-full bg-blue-custom-1 text-gray-custom-1 placeholder-gray-custom-1 mt-3" />
                <Form class="w-full mt-1" @submit="onSubmit" v-slot="{ errors }">
                    <div class="flex flex-col overflow-y-auto w-full gap-3">
                        <div class="card bg-base-200 product-mobile cursor-pointer" v-for="(product, index) in (returnStep == 'add' ? returns : returns.filter(item => item.selected))"
                            v-show="!product?.hidden" @click="setItemReturn(product)">
                            <div class="card-body p-3" :class="{ 'opacity-60 pointer-events-none': isReturn(product) }">
                                <div class="flex">
                                    <div class="relative">
                                        <img class="rounded-lg w-20 h-20" :src="product.image" alt="product" />
                                    </div>
                                    <div class="flex flex-col flex-1 justify-around">
                                        <h1 class="font-bold text-sm text-gray-custom-3 line-clamp-2">{{
                                            product.title }} <span class="text-red-custom-2"
                                                v-if="product.group_sale">({{
                                                    product.group_sale + ' ' +
                                                    __('Integer') }})</span></h1>
                                        <div class="card-actions flex-row items-center justify-between">
                                            <div class="text-xs sm:text-sm">{{ __('Product Code') + ': ' +
                                                (product.code) }}</div>
                                            <ProductQuantity :product="product" @change="changeQuantity"
                                                :max="product.quantity" :min="1" class="!m-[inherit]"
                                                v-if="returnStep == 'add'" />
                                            <div v-if="returnStep == 'record'"><span>{{ __('Quantity') }}:</span>
                                                <span>{{
                                                    product.quantity }}</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-col">
                                    <label class="flex relative" v-if="returnStep == 'record'" :class="{'opacity-70 pointer-events-none cursor-default': product.attachment?.status }">
                                        <span class="btn btn-primary border-l-0 rounded-e-none">{{ __('Select Image')
                                            }}</span>
                                        <Field @change="addAttachment($event, product)" type="file" name="file" :ref="el => fileInputs[index] = el"
                                            class="file-input [&::file-selector-button]:hidden p-2.5 flex-1" accept=".png,.jpeg,.webp,.jpg" />
                                            <!-- <XCircleIcon class="w-5 h-5 text-error absolute top-3 left-3" v-if="product.attachment?.status && product.attachment?.status != 'complete'" /> -->
                                            <CheckCircleIcon class="w-5 h-5 text-success absolute top-3 left-3" v-if="product.attachment?.path"  />
                                    </label>
                                    <div class="w-full flex items-center" v-if="isNumeric(product.attachment?.status)">
                                        <progress class="progress progress-success flex-1" :value="product.attachment.status"
                                            max="100"></progress> <span class="mr-2 inline-block text-sm">
                                                {{ product.attachment.status + '%' }}</span>
                                    </div>
                                </div>
                                <Field as="textarea" class="textarea resize-none" v-if="returnStep == 'record'" :name="`reason_${index}`"
                                    :placeholder="__('Reason for return')" rules="required"
                                    v-model="product.reason" :class="{ 'textarea-error': errors['reason_' + index] }"></Field>
                            </div>
                        </div>
                    </div>
                    <div class="flex mt-4 justify-between items-center">
                        <div class="flex-1">
                            <p v-if="selectedReturns.length">
                                {{ selectedReturns.length + ' ' + __('Selected product') }}</p>
                        </div>
                        <div class="flex gap-2">
                            <router-link class="btn btn-error btn-sm"
                                :to="{ name: 'order', params: { id: $route.params.id } }" type="submit">{{
                                    __('Cancel')
                                }}</router-link>
                            <button class="btn btn-primary btn-sm" v-if="returnStep == 'add'"
                                :disabled="!selectedReturns.length" @click="setReturnStep('record')">{{
                                    __('Continue')
                                }}</button>
                            <button class="btn btn-success btn-sm" v-if="returnStep == 'record'" type="submit">{{
                                __('Submit Request')
                            }}</button>
                        </div>

                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed, onMounted, onUpdated, ref } from 'vue';
import {
    ArrowDownTrayIcon,
    ArrowSmallRightIcon,
    TrashIcon,XCircleIcon,CheckCircleIcon
} from '@heroicons/vue/24/outline'
import ProductQuantity from './ProductQuantity.vue';
import useOrders from "../../../composables/shop/order";
import { Field, Form } from "vee-validate";
import useUpload from '../../../composables/shop/upload';
const { errors, loading, returns, storeItemReturn, getItemReturn } = useOrders();
const { uploadFile,controller } = useUpload();
const returnStep = ref('add');
const fileInputs = ref([]);
const getData = () => getItemReturn();
const addAttachment = (event, item) => {
    item.attachment = { status: 'uploading' };
    uploadFile(event, 'image', item.attachment);
}
const setItemReturn = (item) => {
    if (returnStep.value == 'record' || item.quantity == 0) return;
    const index = returns.value.findIndex(r => r.id == item.id);
    returns.value[index] = { ...returns.value[index], selected: !item.selected };
}
const changeQuantity = (product, quantity) => {
    const index = returns.value.findIndex(r => r.id == product.id);
    if (index !== -1) returns.value[index] = { ...returns.value[index], quantity };
}
const selectedReturns = computed(() => returns.value.filter(item => item.selected));
const isReturn = (product) => !returns.value.filter(item => item.selected).map(item => item.id).includes(product.id);
const onSubmit = () => {
    storeItemReturn();
}
function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
const searchProduct = (e) => {
    let data = returns.value;
    data = data.map(item => {
        item['hidden'] = !item.title.includes(e.target.value);
        return item;
    });
}
const removeFile = (index) => {
  returns.value[index].attachment = null;
  controller.value?.abort();
  if (fileInputs.value[index]) fileInputs.value[index].value = "";
}
const setReturnStep = (step) => returnStep.value = step;
onMounted(() => getData());
</script>